import React, { Component } from 'react';
import { authentication } from '../services/Authentication';
import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalFooter from "react-bootstrap/ModalFooter";
import ModalTitle from "react-bootstrap/ModalTitle";
import helpers from '../Function';

export default class Header extends Component {

    componentDidMount() {
        helpers.checklogin(this.state.jwt);
    }

    constructor(props) {
        super(props);

        const { name, user_type, jwt } = authentication.currentUserValue;
        this.state = {
            name: name,
            user_type: user_type,
            logoutIsOpen: false,
            jwt: jwt
        }
        //console.log("*******"+JSON.stringify(authentication));
        this.LogoutSubmit = this.LogoutSubmit.bind(this);
        this.closeLogoutCancel = this.closeLogoutCancel.bind(this);
        this.openLogoutCancel = this.openLogoutCancel.bind(this);
    }

    LogoutSubmit() {
        authentication.logout();
        //history.push('/login');
    }

    closeLogoutCancel() {
        this.setState({ logoutIsOpen: false });
    }

    openLogoutCancel() {
        this.setState({ logoutIsOpen: true });
    }

    render() {
        return (
            <nav className="main-header navbar navbar-expand navbar-white navbar-light">
                {/* Left navbar links */}
                <ul className="navbar-nav">
                    <li className="nav-item">
                        <a className="nav-link" data-widget="pushmenu" href="#/"><i className="fas fa-bars" /></a>
                    </li>
                    <li className="nav-item d-none d-sm-inline-block">
                        <a href="#/" className="nav-link">Admin</a>
                    </li>
                </ul>
                {/* SEARCH FORM
            <form className="form-inline ml-3">
                <div className="input-group input-group-sm">
                <input className="form-control form-control-navbar" type="search" placeholder="ค้นหา" aria-label="Search" />
                <div className="input-group-append">
                    <button className="btn btn-navbar" type="submit">
                    <i className="fas fa-search" />
                    </button>
                </div>
                </div>
            </form> */}
                {/* Right navbar links */}
                <ul className="navbar-nav ml-auto" style={{ alignItems: "center"}}>
                    {/* Messages Dropdown Menu */}
                    {/* <li className="nav-item"> 
                        <div className="btn-add text-center btn-sm" style={{ margin: "3px 10px", width: "80px" }} ><a href={'http://callcenter.devtester.net/'} style={{ color: 'black' }} target="_blank">Call Center</a></div>
                    </li> */}
                    <li className="nav-item">
                        <div style={{ borderLeft: "1.5px", height: "34px" }}></div>
                    </li>
                    <li className="nav-item">
                        <img src={"../dist/img/icon/ic_user_login_01.png"} width={30} height="auto" alt="User_Image" />
                    </li>
                    <li className="nav-item">
                        <a href="#/" className="nav-link" style={{ color: '#162540', paddingRight: 0, paddingLeft: 5 }}>{this.state.name}</a>
                    </li>
                    <li className="nav-item dropdown user-menu">
                        <a className="nav-link" data-toggle="dropdown" href="#/" style={{ paddingLeft: 4 }}>
                            <img src={"../dist/img/icon/ic_dropdown.png"} width="20px" height="auto" alt="User_Image" />
                        </a>
                        <ul className="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                            {/* Menu Body */}

                            <li className="user-body">
                                <p>
                                    {this.state.name} - Call Center
                                <small>Member since Nov. 2019</small>
                                </p>
                            
                            </li>
                            {/* Menu Footer*/}
                            <li className="user-footer">
                                <div className="pull-right" style={{ float: 'right' }}>
                                    <button onClick={this.openLogoutCancel} className="btn btn-default btn-flat">Sign out</button>
                                </div>
                            </li>
                        </ul>
                    </li>
                </ul>
                <Modal show={this.state.logoutIsOpen} onHide={this.closeLogoutCancel}>
                    <ModalHeader>
                        <ModalTitle>ผลการตรวจสอบ</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <h3>คุณต้องการออกจากระบบใช่หรือไม่</h3>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeLogoutCancel}>ยกเลิก</button>
                        <button className="btn btn-info" onClick={this.LogoutSubmit}>ตกลง</button>
                    </ModalFooter>
                </Modal>
            </nav>
        );
    }
};